export default __webpack_public_path__ + "static/media/cover-icon.0d7f40d0.svg";